// extracted by mini-css-extract-plugin
module.exports = {"outside":"index-module__outside___1Splc","admin":"index-module__admin___39TH-"};